import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {AnimatedParticle, Emitter} from "pixi-particles";
import {WGGameConfig} from "../../../WGGameConfig";
import {ParticlesManager} from "@nolimitcity/slot-game/bin/core/particles/ParticlesManager";
import {TweenLite} from "gsap";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";

require("pixi-particles");


export class CoinsFountain extends BaseView {

    private readonly _screenHeightRange: [number, number] = [720, 1760];
    private readonly _startSpeedRange: [number, number] = [650, 950];
    private _coinsEmiters: Emitter[] = [];
    private _layer: ScalableLayer;
    private _isPlaying: boolean = false;
    private _initMaxParticles: number = 150;
    private _dimDownGraphics: PIXI.Graphics;
    private _particles_layer: ScalableLayer;
    private _orangePatch: PIXI.Sprite;
    private readonly _coinsConfigs: any[] = [
        {
            "alpha": {
                "start": 1,
                "end": 0.4
            },
            "scale": {
                "start": 0.7,
                "end": 0.1,
                "minimumScaleMultiplier": 1
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },
            "speed": {
                "start": 10,
                "end": 20,
                "minimumSpeedMultiplier": 1
            },
            "acceleration": {
                "x": 0,
                "y": -50
            },
            "maxSpeed": 280,
            "startRotation": {
                "min": 280,
                "max": 255
            },
            "noRotation": true,
            "rotationSpeed": {
                "min": 5,
                "max": 5
            },
            "lifetime": {
                "min": 0.5,
                "max": 1
            },
            "blendMode": "add",
            "frequency": 0.1,
            "emitterLifetime": -1,
            "maxParticles": this._initMaxParticles,
            "pos": {
                "x": 0,
                "y": 0,
            },
            "addAtBack": false,
            "spawnType": "rect",
            "spawnRect": {
                "x": 0,
                "y": 0,
                "w": WGGameConfig.instance.GAME_WIDTH - 40,
                "h": 1
            }
        }, {
            "alpha": {
                "start": 1,
                "end": 0.4
            },
            "scale": {
                "start": 0.7,
                "end": 0.1,
                "minimumScaleMultiplier": 1
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },
            "speed": {
                "start": 10,
                "end": 20,
                "minimumSpeedMultiplier": 1
            },
            "acceleration": {
                "x": 0,
                "y": -50
            },
            "maxSpeed": 320,
            "startRotation": {
                "min": 280,
                "max": 255
            },
            "noRotation": true,
            "rotationSpeed": {
                "min": 5,
                "max": 5
            },
            "lifetime": {
                "min": 0.5,
                "max": 1
            },
            "blendMode": "add",
            "frequency": 0.1,
            "emitterLifetime": -1,
            "maxParticles": this._initMaxParticles,
            "pos": {
                "x": 0,
                "y": 0,
            },
            "addAtBack": false,
            "spawnType": "rect",
            "spawnRect": {
                "x": 0,
                "y": 0,
                "w": WGGameConfig.instance.GAME_WIDTH - 40,
                "h": 1
            }
        }, {
            "alpha": {
                "start": 1,
                "end": 0.4
            },
            "scale": {
                "start": 0.7,
                "end": 0.1,
                "minimumScaleMultiplier": 1
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },
            "speed": {
                "start": 10,
                "end": 20,
                "minimumSpeedMultiplier": 1
            },
            "acceleration": {
                "x": 0,
                "y": -50
            },
            "maxSpeed": 380,
            "startRotation": {
                "min": 280,
                "max": 255
            },
            "noRotation": true,
            "rotationSpeed": {
                "min": 5,
                "max": 5
            },
            "lifetime": {
                "min": 0.5,
                "max": 1
            },
            "blendMode": "add",
            "frequency": 0.1,
            "emitterLifetime": -1,
            "maxParticles": this._initMaxParticles,
            "pos": {
                "x": 0,
                "y": 0,
            },
            "addAtBack": false,
            "spawnType": "rect",
            "spawnRect": {
                "x": 0,
                "y": 0,
                "w": WGGameConfig.instance.GAME_WIDTH - 40,
                "h": 1
            }
        }, {
            "alpha": {
                "start": 1,
                "end": 0.4
            },
            "scale": {
                "start": 0.7,
                "end": 0.5,
                "minimumScaleMultiplier": 1
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },
            "speed": {
                "start": 10,
                "end": 20,
                "minimumSpeedMultiplier": 1
            },
            "acceleration": {
                "x": 0,
                "y": -50
            },
            "maxSpeed": 420,
            "startRotation": {
                "min": 280,
                "max": 255
            },
            "noRotation": true,
            "rotationSpeed": {
                "min": 5,
                "max": 5
            },
            "lifetime": {
                "min": 0.5,
                "max": 1
            },
            "blendMode": "add",
            "frequency": 2,
            "emitterLifetime": -1,
            "maxParticles": 10,
            "pos": {
                "x": 0,
                "y": 0,
            },
            "addAtBack": false,
            "spawnType": "rect",
            "spawnRect": {
                "x": 0,
                "y": 0,
                "w": WGGameConfig.instance.GAME_WIDTH - 40,
                "h": 1
            }
        }
    ];

    public startFountain(playLevel: number): void {
        this._dimDownGraphics.visible = true;
        if (!this._isPlaying) {
            this._orangePatch.visible = true;
            this._coinsEmiters.forEach(value => value.emit = true);
            this._isPlaying = true;
        } else {
            TweenLite.to(this._orangePatch.scale, 1, {y: this._orangePatch.scale.y + 0.5})
            this._coinsEmiters.forEach(value => {
                value.maxLifetime = value.maxLifetime + 0.2;
                value.minLifetime = value.minLifetime + 0.2;
            });
        }
    }

    private orangePatchAlignement(): void {
        const screenHeight: number = Math.round(this._resizeData.height / this._layer.scale.y);
        const width: number = this._resizeData.orientation === Orientation.LANDSCAPE ? 0.5 : 0.25;
        this._orangePatch.position.set(this._particles_layer.x + this._orangePatch.width * width, screenHeight - this._orangePatch.height / 4);
    }

    public stopFountain(): void {
        this._isPlaying = false;
        this._dimDownGraphics.visible = false;
        this._orangePatch.scale.set(1.5);
        this.orangePatchAlignement();
        this._orangePatch.visible = false;
        this._coinsEmiters.forEach(value => {
            value.emit = false;
            value.maxParticles = this._initMaxParticles;
            value.maxLifetime = 1;
            value.minLifetime = 0.5;
        });
    }

    protected initAnimations(): void {
        this._orangePatch = new PIXI.Sprite(GameResources.getTextures("Orange_patch")[0]);
        this._orangePatch.blendMode = PIXI.BLEND_MODES.ADD;
        this._orangePatch.anchor.set(0.5);
        this._orangePatch.scale.set(1.5);
        this._orangePatch.visible = false;

        this._layer = StageManager.getLayer(WGGameConfig.instance.LAYERS.COIN_FOUNTAIN.name);
        this._particles_layer = StageManager.getLayer(WGGameConfig.instance.LAYERS.PARTICLES.name);
        this._particles_layer.addChild(this._orangePatch);
        this._coinsEmiters = [];
        this._coinsConfigs.forEach((value, index: number) => {
            const emitter: Emitter = new Emitter(this._particles_layer, [{
                framerate: 30,
                hasLoaded: true,
                textures: [(GameResources.getTextures(`bigWinFireParticle${index + 1}`)[0])]
            }], this._coinsConfigs[0]);
            emitter.particleConstructor = AnimatedParticle;
            ParticlesManager.addEmitter(emitter, false);
            this._coinsEmiters.push(emitter);
        });
    }

    /**
     * create background alpha
     */
    public createBackgroundDimmer(visibility: boolean): PIXI.Graphics {
        const blackAlpha = new PIXI.Graphics();
        blackAlpha.beginFill(0x000000);
        blackAlpha.drawRect(0,
            0,
            NolimitApplication.screenBounds.width,
            NolimitApplication.screenBounds.height);
        blackAlpha.alpha = 0.8;
        blackAlpha.visible = visibility;
        blackAlpha.endFill();
        this._layer.addChildAt(blackAlpha, 0);
        return blackAlpha;
    }

    protected onResize(resizeData: IResizeData): void {
        this._layer.position.set(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top);
        this._particles_layer.position.set(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top);
        // to fix #156
        let visibility: boolean = this._dimDownGraphics?.visible ? true : false;
        this._dimDownGraphics?.clear();
        this._dimDownGraphics = this.createBackgroundDimmer(visibility);

        let screenHeight: number = Math.round(resizeData.height / this._layer.scale.y);
        screenHeight = Math.max(this._screenHeightRange[0], Math.min(screenHeight, this._screenHeightRange[1]));
        const startSpeed: number = Math.round((screenHeight - this._screenHeightRange[0]) * (this._startSpeedRange[1] - this._startSpeedRange[0]) / (this._screenHeightRange[1] - this._screenHeightRange[0]) + this._startSpeedRange[0]);

        const levelSpeed: number = startSpeed * (2);
        this._coinsEmiters.forEach((value, index) => {
            value.startSpeed.value = levelSpeed + (1 + 0.05);
            value.spawnPos.y = this._resizeData.height;
            value.spawnRect.width = this._resizeData.width;
        });
        this.orangePatchAlignement();
    }
}